/*----------------------------------
- SALES PAGE: LOOKUP CARD
----------------------------------*/

/**
 * @docs docs/features/sales-page
 * @adr  ADR-0067
 * @rule The visitor's one lookup of the day, as Product answered it: four aggregates of the word
 *       or "no usable sale yet", and a way to every sale of the word in Product. Never a sale.
 */

import { formatSalesCount, formatSalesMonthYear, formatSalesUsd } from '@uniquedomains/components/contracts/sales/format';
import type { SalesLookupResult } from '@uniquedomains/components/contracts/sales/public';

import { SALES_PAGE_CONTENT } from '@/client/catalogs/landing/sales/pageContent';

/*----------------------------------
- COMPONENT
----------------------------------*/

export default function SalesLookupCard({ result, onOpen }: { result: SalesLookupResult; onOpen: (word: string) => void }) {
    const copy = SALES_PAGE_CONTENT.lookup;
    if (result.status === 'gate') return null;
    if (result.status === 'invalid') {
        return <p class="ud-sales__lookup" data-testid="sales-lookup-invalid">{copy.invalid}</p>;
    }
    if (result.status === 'none') {
        return <p class="ud-sales__lookup" data-testid="sales-lookup-none">{copy.none(result.word)}</p>;
    }
    return (
        <div class="ud-sales__lookup" data-testid="sales-lookup-result">
            <strong>{copy.result(result.word)}</strong>
            <span>
                {[
                    copy.sales(formatSalesCount(result.sales12m)),
                    result.median12mUsd === null ? null : copy.median(formatSalesUsd(result.median12mUsd)),
                    copy.endings(result.endingsSoldOn),
                    result.lastSaleMonth ? copy.lastSale(formatSalesMonthYear(`${result.lastSaleMonth}-01`)) : null,
                ].filter(Boolean).join(' · ')}
            </span>
            <button type="button" class="ud-sales__lookup-cta" onClick={() => onOpen(result.word)} data-testid="sales-lookup-cta">
                {copy.cta}
            </button>
        </div>
    );
}
